import { gql } from '@apollo/client'

export const CheckStatus = gql`
  query Supplier($address: String!) {
    supplier(address: $address) {
      whitelisted
    }
  }
`
